export const ROLES = {
  ADMIN: "admin",
  subAdmin: "subAdmin",
  CREDIT_MANAGER: "credit-manager",
  STAFF: "staff",
  BANKING_PARTNER: "banking-partner",
  AFFILIATE_PARTNER: "affiliate-partner",
};

export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: {
    canManageAllUsers: true,
    canViewAllData: true,
    canManageBankingPartners: true,
    canManageAffiliatePartners: true,
    canManageStaff: true,
    canManageCreditManagers: true,
    canViewReports: true,
    canManageSystemSettings: true,
    canApproveLoans: true,
    canViewFinancials: true,
    canManageRoles: true,
  },
  [ROLES.subAdmin]: {
    canManageStaff: true,
    canViewAssignedData: true,
    canViewReports: true,
    canApproveLoans: false,
    canManageBankingPartners: false,
    canViewFinancials: true,
    canManageCustomers: true,
  },
  [ROLES.CREDIT_MANAGER]: {
    canViewAssignedData: true,
    canApproveLoans: true,
    canViewCustomerDetails: true,
    canGenerateReports: true,
    canManageDocuments: true,
    canViewFinancials: true,
    canCommunicateWithPartners: true,
  },
  [ROLES.STAFF]: {
    canViewAssignedCustomers: true,
    canProcessApplications: true,
    canUploadDocuments: true,
    canCommunicateWithCustomers: true,
    canViewBasicReports: true,
    canCreateCustomers: true,
  },
  [ROLES.BANKING_PARTNER]: {
    canViewOwnProfile: true,
    canViewAssignedApplications: true,
    canUpdateLoanStatus: true,
    canUploadDocuments: true,
    canViewPartnerReports: true,
    canCommunicateWithStaff: true,
  },
  [ROLES.AFFILIATE_PARTNER]: {
    canViewOwnProfile: true,
    canReferCustomers: true,
    canViewCommissions: true,
    canViewReferralStatus: true,
    canGenerateReferralLinks: true,
    canViewPerformanceMetrics: true,
  },
};

export const ROLE_ROUTES = {
  [ROLES.ADMIN]: "/admin/dashboard",
  [ROLES.subAdmin]: "/subAdmin/dashboard",
  [ROLES.CREDIT_MANAGER]: "/credit-manager/dashboard",
  [ROLES.STAFF]: "/staff/dashboard",
  [ROLES.BANKING_PARTNER]: "/banking-partner/dashboard",
  [ROLES.AFFILIATE_PARTNER]: "/affiliate-partner/dashboard",
};
